import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import Sidenav from "../screens/sidenav/sidenav";
import Navbar from "../screens/navbar/navbar";
import Dashboard from "../screens/Dashboard/dashboard/dashboard";
import UserManagement from "../screens/Dashboard/user_management/user_management";
import FinanceManagement from "../screens/Dashboard/finance_management/finance";
import ReviewManagement from "../screens/Dashboard/review_management/review";
import Support from "../screens/Dashboard/grati_support/support";
import ManageAdmins from "../screens/Dashboard/manage_admins/manage_admins";
import Notifications from "../screens/navbar/notifications/notifications";
import GratiTipDetails from "../screens/Dashboard/finance_management/grati_tip_details/grati_tip_details";
import SubscriptionDetails from "../screens/Dashboard/finance_management/subscription_details/subscription_details";
import RevenueReports from "../screens/Dashboard/finance_management/revenue_reports/revenue_reports";
import { profileDetails } from "../API/myProfileApi";
import { userActions } from "../redux/reducers/user";
import "../screens/Dashboard/manage_admins/manageEdit.css";
import ManageCollaboration from "../screens/Dashboard/manage_collaboration/manage_collaboration";
import OrderManagement from "../screens/Dashboard/order_management/order_management";
import ProductManagement from "../screens/Dashboard/product_management/product_management";
import OtpScreen from "../screens/OtpScreen/OtpScreen";

const AuthenticatedRoutes = () => {
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.user.permissions)[0];
  const role = useSelector((state) => state.user.role);

  useEffect(() => {
    profileDetails().then((response) =>
      dispatch(userActions.storeUser(response.data.data[0]))
    );
  }, []);

  const canAccess = (permission) => role === 0 || permissions?.[permission];

  return (
    <div className="flex flex-row">
      <Sidenav />

      <div className="card flex flex-col w-full">
        <Navbar />
        <div className="p-8 bg-gray-100 h-full">
          <Routes>
            {canAccess("DASHBOARD") && (
              <Route path="dashboard" element={<Dashboard />} />
            )}
            {canAccess("USER_MANAGEMENT") && (
              <Route path="user_management" element={<UserManagement />} />
            )}
            {canAccess("FINANCE") && (
              <>
                <Route
                  path="finance_management"
                  element={<FinanceManagement />}
                />
                <Route
                  path="finance_management/grati_tip_details"
                  element={<GratiTipDetails />}
                />
                <Route
                  path="finance_management/subscription_details"
                  element={<SubscriptionDetails />}
                />
                <Route
                  path="finance_management/revenue_reports"
                  element={<RevenueReports />}
                />
              </>
            )}
            {canAccess("REVIEW_AND_FEEDBACK") && (
              <Route path="review_management" element={<ReviewManagement />} />
            )}
            {role === 0 && <Route path="grati_support" element={<Support />} />}
            {canAccess("SUB_ADMIN_MANAGEMENT") && (
              <Route path="manage" element={<ManageAdmins />} />
            )}

            <Route path="order_management" element={<OrderManagement />} />
            <Route path="product_management" element={<ProductManagement />} />

            {role === 0 && (
              <Route
                path="manage_collaboration"
                element={<ManageCollaboration />}
              />
            )}
            <Route path="notifications" element={<Notifications />} />
            <Route path="*" element={<Navigate replace to="dashboard" />} />
            <Route path="/otpscreen" element={<OtpScreen />} />

          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AuthenticatedRoutes;
